<template>
  <div class="app-container">
    <div class="app-content">
      <el-card
        v-loading="formLoading"
        class="station-setting__card"
        shadow="never"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form ref="stationSettingForm" :model="formModel" :rules="formRules">
          <el-form-item label="电站图片 仅支持jpg、jpeg、png格式">
            <img-upload ref="imgUpload" v-model="formModel.img" style="width: 100%;display: inline-block;" />
          </el-form-item>
          <el-form-item :label="$t('text.dbdzmc')" prop="orgname">
            <el-input v-model="formModel.orgname" clearable />
          </el-form-item>
          <el-form-item :label="$t('text.stationProvince')" prop="province">
            <el-select v-model="formModel.province" placeholder="请选择省份" filterable clearable>
              <el-option v-for="(item, index) in provinceOptions" :key="index" :label="item.key" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.shiqu')" prop="tzonecode">
            <el-select v-model="formModel.tzonecode" placeholder="请选择时区" filterable clearable>
              <el-option v-for="(item, index) in timezoneOptions" :key="index" :label="item.key" :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item prop="capacity">
            <template #label>
              {{ $t('text.zjrl') }},单位：kWp
            </template>
            <el-input-number v-model="formModel.capacity" controls-position="right" :min="1" :step="0.001" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="updateLoading" @click="handleUpdateSubmit">
              {{ $t('button.bc') }}</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@views/Imgupload'
import { GetAddresses, GetTimeZones } from '@apis/Universal.js'
import { UpdateMeterStation, GetStation } from '@apis/Stations.js'
const stationImagePath = `${process.env.VUE_APP_BASE_API}/imgs/stations`
export default {
  components: {
    ImgUpload
  },
  data () {
    return {
      /** 时区选项 */
      timezoneOptions: [],
      /** 省份选项 */
      provinceOptions: [],
      /** 表单模型 */
      formModel: {
        id: '',
        img: '',
        orgname: '',
        province: '',
        tzonecode: '101',
        capacity: ''
      },
      /** 表单验证规则 */
      formRules: {
        orgname: [{ required: true, message: '请输入电站名称', trigger: 'blur' }],
        province: [{ required: true, message: '请输入电站省份名称', trigger: 'change' }],
        tzonecode: [{ required: true, message: '请选择时区', trigger: 'change' }],
        capacity: [{ required: true, message: '请输入电站容量', trigger: 'blur' }]
      },
      /** 表单加载状态 */
      formLoading: false,
      /** 更新加载状态 */
      updateLoading: false
    }
  },
  mounted () {
    this.getTimeZoneAndProvinceOptions().then(() => {
      this.getStationInfo()
    })
  },
  methods: {

    /** 获取时区和省份选项 */
    getTimeZoneAndProvinceOptions () {
      return new Promise((resolve, reject) => {
        Promise.all([GetTimeZones({ id: '' }), GetAddresses({ id: '44' })]).then(res => {
          this.timezoneOptions = res[0].data
          this.provinceOptions = res[1].data
          resolve(res)
        }).catch(err => {
          this.$message({
            message: '获取选项失败',
            type: 'error'
          })
          reject(err)
        })
      })
    },

    /** 获取电站信息 */
    getStationInfo () {
      this.formLoading = true
      GetStation({
        id: this.$store.getters.station.id
      }).then(res => {
        const { capacity, province, img, orgname, tzonecode } = res.data
        this.formModel.capacity = capacity
        this.formModel.province = province
        this.formModel.tzonecode = tzonecode
        this.formModel.orgname = orgname
        this.formModel.img = `${stationImagePath}/${img}`
        this.formModel.id = this.$store.getters.station.id
      }).then(() => {
        this.formLoading = false
      }).catch(() => {
        this.formLoading = false
      })
    },

    /** 更新电站信息 */
    handleUpdateSubmit () {
      this.$refs.stationSettingForm.validate().then(() => {
        this.updateLoading = true
        const postData = {
          ...this.formModel,
        }
        if (postData.img.indexOf('base64') === -1) {
          postData.img = null
        }
        UpdateMeterStation(postData).then(() => {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getStationInfo()
        }).then(() => {
          this.updateLoading = false
        }).catch(() => {
          this.updateLoading = false
        })
      })
    }
  }
}
</script>
<style scoped>
.station-setting__card {
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}
.station-setting__card >>>.el-card__body{
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.station-setting__card >>>.el-card__body .el-form{
  width: 100%;
  height: 100%;
  padding: 0px;
  box-sizing: border-box;
}
</style>

